<a href="/" class="inline-block">
  <ion-img
    src="/assets/images/koshery-icon.svg"
    alt="Koshery.com icon"
    class="w-8"
  />
</a>
